import ShooterGame from './ShooterGame';
import { shooterDefinition } from './shooterDefinition';

const shooterIcon = {
  id: 'shooter',
  src: `${process.env.PUBLIC_URL}/player-ship.png`,
};

export const shooterGameModule = {
  id: shooterDefinition.id,
  name: shooterDefinition.shortName,
  summary: shooterDefinition.summary,
  component: ShooterGame,
  definition: shooterDefinition,
  accent: 'cyan',
  icon: shooterIcon,
  releaseState: 'released',
  controls: {
    movement: 'analog-2d',
    actions: ['confirm'],
    notes: 'Auto-fire shooter movement.',
  },
  playableIcons: [
    { id: 'shooter', name: 'Falcon', icon: shooterIcon },
    { id: 'shooter-comet', name: 'Comet', icon: { ...shooterIcon, id: 'shooter-comet', baseId: 'shooter' } },
    { id: 'shooter-vanguard', name: 'Vanguard', icon: { ...shooterIcon, id: 'shooter-vanguard', baseId: 'shooter' } },
  ],
};
